import React from 'react';
import PropTypes from 'prop-types';
import { Sider } from './styles';
import Base from './base';

const SideBar = ({
  trigger,
  opened,
  collapsible,
  theme,
  breakpoint,
  onCollapse,
  width,
  ...props
}) => (
  <Sider
    trigger={trigger}
    collapsed={!opened}
    collapsible={collapsible}
    theme={theme}
    breakpoint={breakpoint}
    onCollapse={onCollapse}
    width={width}
  >
    <Base theme={theme} {...props} />
  </Sider>
);

SideBar.displayName = 'SideBar.Sider';

SideBar.propTypes = {
  ...Sider.propTypes,
  ...Base.propTypes,
  trigger: PropTypes.node,
  collapsible: PropTypes.bool,
  opened: PropTypes.bool,
  onCollapse: PropTypes.func,
};

SideBar.defaultProps = {
  ...Sider.defaultProps,
  ...Base.defaultProps,
  trigger: null,
  collapsible: true,
  opened: true,
  breakpoint: 'sm',
  onCollapse: () => null,
};

export default SideBar;
